<template>
<div>
    <div class="stop-wrap" v-if="isPc === 0">
        <div class="inner-wrap">
            <div class="inner-pic"></div>
            <div class="inner-logo"></div>
            <div class="btn-wrap">
                <el-button class="calender" @click="addIcs">Add to calendar</el-button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'stop',
  data () {
    return {
        isPc: 2,
        route_infomation: {}
    }
  },
  created() {
    this.route_infomation = this.$route.query
    let u = navigator.userAgent
    if (!!u.match(/compatible/i) || u.match(/Windows/i)) {
        this.isPc = 1
    } else if (!!u.match(/Macintosh/i) || u.match(/MacIntel/i)) {
        this.isPc = 1
    }  else if (!!u.match(/iphone/i) || u.match(/Ipad/i)) {
        this.isPc = 0
    } else if (!!u.match(/android/i)) {
        this.isPc = 0
    } else {
        this.isPc = 1
    }
    let route_infomation = this.$route.query
    if (!route_infomation)
        return
    if (this.isPc === 1) {
        Utils.alert('', ' This link will only work on iOS or Android.','error')
        return
    }
  },
  methods: {
    addIcs() {
        window.open('data:text/calendar;charset=utf8,' + encodeURI(this.getCalenderFile()));
    },
    getCalenderFile(){
        let route_infomation = this.$route.query
        if (!route_infomation || !route_infomation.date)
            return

        let date = route_infomation.date
        
        let date_without_symbols = date.split('-').join('')

        const startDateTime = `${date_without_symbols}T080000`;

        const endDateTime = `${date_without_symbols}T090000`;

        const datetime = "";

        const location = "";

        const icsMSG = 'BEGIN:VCALENDAR\nPRODID:-//Microsoft Corporation//Outlook 16.0 MIMEDIR//EN\nVERSION:2.0\nMETHOD:REQUEST\nX-MS-OLK-FORCEINSPECTOROPEN:TRUE\nBEGIN:VEVENT\nDESCRIPTION:'
         + datetime + '' + location + '\nDTSTART;TZID="":'
         + startDateTime + '\nDTEND;TZID="":'
         + endDateTime + '\n'
         '\nSUMMARY;LANGUAGE=en-sg:You have a appointment\nX-MICROSOFT-CDO-BUSYSTATUS:TENTATIVE\nX-MICROSOFT-CDO-IMPORTANCE:1\nX-MICROSOFT-CDO-INTENDEDSTATUS:BUSY\nX-MICROSOFT-DISALLOW-COUNTER:FALSE\nX-MS-OLK-CONFTYPE:0\nBEGIN:VALARM\nTRIGGER:-PT15M\nACTION:DISPLAY\nDESCRIPTION:Reminder\nEND:VALARM\nEND:VEVENT\nEND:VCALENDAR\n';
        
        return icsMSG;
    }
  }
}
</script>

<style lang="scss" scoped>
.stop-wrap{
    background: #3A3835;
    min-width: 375px;
    min-height: 90vh;
    .inner-wrap{
        width: 85.33%;
        max-width: 320px;
        margin: 0 auto;
        padding: 18.75% 0 0 0;
        .inner-pic{
            width: 100%;
            padding-bottom: 100%;
            background-image: url('../../assets/login/stop.png');
            background-repeat: no-repeat;
            background-size: 100% auto;
            margin-bottom: 12.5%;
        }
        .inner-logo{
            width: 27.5%;
            padding-bottom: 13.125%;
            background-image: url('../../assets/login/logo.png');
            background-repeat: no-repeat;
            background-size: 100% auto;
            margin: 0 auto 29.0625% auto;
        }
        .btn-wrap{
            padding-bottom: 10%;
        }
        .calender{
            display: block;
            width: 98%;
            height: 53px;
            border: none;
            background: #F8A4AE;
            border-radius: 4px;
            font-size: 17px;
            font-family: Assistant-Bold, Assistant;
            font-weight: bold;
            color: #3A3835;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/sign/stop.vue